import React from 'react';
import kartinka from './store_pictures/topbanner.jpg'; // Путь к изображению
import { Link } from 'react-router-dom';
import './style/TopBanner.css'; // Стили для баннера

function TopBanner() {
return (
    <div className="topbanner-container1">
            <img src={kartinka} alt="Описание картинки" className="topbanner-image-topbanner" />
        <div className="topbanner-container2">
            <div className="topbanner-overlay">
                <div>
                    <span className="topbanner-overlay-text1">Бесплатная</span>
                    <span className="topbanner-overlay-text1">доставка</span>
                </div>
                <div>
                    <span className="topbanner-overlay-text2">от 10 000 Т</span>
                </div>
            </div>
            <div className="topbanner-button-container">
                <Link to="/Catalog">
                    <button className="topbanner-topbanner-button">
                        К покупкам &#8594;
                    </button>
                </Link>
            </div>
        </div>
    </div>
);
}

export default TopBanner;
